import {
  BaseInputProps,
  NumberInput,
  RelativeRow,
  TextInput,
  useFormContextRequired,
  useInputHelper
} from 'ui-builder';
import { ParentTaskRelation, PlanTask } from 'nekst-api';
import React from 'react';
import { DueDateConfigInputProps } from './DueDateConfigInput';

interface DisabledTaskNameInputProps extends BaseInputProps<ParentTaskRelation> {

}

function DisabledTaskNameInput(props: DisabledTaskNameInputProps) {
  const helper = useInputHelper<ParentTaskRelation>(props);

  return (
    <TextInput
      label={props.label}
      source={`${props.source}.name`}
      value={helper.getValue().parentTaskName}
      onChangeCallback={() => {
        // ignored
      }}
      isDisabled
    />
  );
}

export function PlanParentTaskRelationInput(props: DueDateConfigInputProps) {

  const formContext = useFormContextRequired<PlanTask>();

  const isProceeding = formContext.data?.parentTaskRelation?.isProceeding;

  const label = isProceeding
    ? 'Days Before This Task Due Date'
    : 'Days After This Task Completion';

  return (
    <RelativeRow weights={[4, 8]} useFlex toBottom>
      <NumberInput source={`${props.source}.days`} label={props.label} hideValidationErrors />
      <DisabledTaskNameInput
        source={`${props.source}`}
        label={label}
      />
    </RelativeRow>
  );
}
